<script>
    import {Link} from './router';

    export let page = null;
    export let totalItems = null;
    export let target = null;
    export let itemsPerPage = null;
    export let cnt = 12
    let totalPages;
    let startPage = 0;
    let endPage  = 0;

    let pages = [];

    $: {
        totalPages = Math.ceil(totalItems / itemsPerPage);
        page = Number(page)
        startPage = page - cnt/2;
        if (startPage < 1) {
            startPage = 1;
        }
        endPage = startPage + cnt;
        if (endPage > totalPages) {
            endPage = totalPages;
            if (totalPages > cnt) {
                startPage = endPage - cnt;
            }
        }
        pages.length = endPage - startPage + 1;
    }

</script>

{#if (totalPages > 1)}
    <ul>
        {#if (page > 1)}
            <li>
                <Link href="/app/{ target }/{ page - 1 }">← προηγ</Link>
            </li>
        {/if}

        {#each pages as mmm, index}
            <li class:active="{ index + startPage == page }">
                <Link href="/app/{ target }/{ index + startPage }">{ index + startPage }</Link>
            </li>
        {/each}
        {#if (page + 1 <= totalPages)}
            <li>
                <Link href="/app/{ target }/{ page + 1 }">επόμ →</Link>
            </li>
        {/if}
    </ul>
{/if}